import { render, staticRenderFns } from "./VendedoresLista.vue?vue&type=template&id=2ef1ea52&scoped=true&"
import script from "./VendedoresLista.vue?vue&type=script&lang=js&"
export * from "./VendedoresLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef1ea52",
  null
  
)

export default component.exports